/**
 * Powers the mobile-only "Technical Benefits" slider: dot pagination, and
 * previous/next arrows that advance the horizontally scrolling,
 * scroll-snapped list of benefit cards. Kept as its own small asset file
 * rather than folding into an existing larger JS asset, to stay well under
 * the theme write API's ~29.5KB payload limit for this project.
 */
(function () {
  function initSlider(root) {
    if (root.dataset.tbBound === 'true') return;

    var track = root.querySelector('[data-tb-track]');
    var dots = root.querySelectorAll('[data-tb-dot]');
    var prevBtn = root.querySelector('[data-tb-prev]');
    var nextBtn = root.querySelector('[data-tb-next]');
    if (!track) return;

    root.dataset.tbBound = 'true';

    function slideWidth() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var rect = first.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return rect.width + gap;
    }

    function currentIndex() {
      var w = slideWidth();
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }

    function updateDots() {
      var idx = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(updateDots);
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var w = slideWidth();
        var maxScroll = track.scrollWidth - track.clientWidth;
        var next = Math.min(track.scrollLeft + w, maxScroll);
        track.scrollTo({ left: next, behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var w = slideWidth();
        var prev = Math.max(track.scrollLeft - w, 0);
        track.scrollTo({ left: prev, behavior: 'smooth' });
      });
    }

    updateDots();
    window.addEventListener('resize', updateDots);
  }

  function initAll() {
    document.querySelectorAll('[data-technical-benefits-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
